import {
  type MetaCapiCohortSummaryResponse,
  MetaCapiCohortSummaryResponseSchema,
  type MetaCapiConfigStatus,
  MetaCapiConfigStatusSchema,
  type MetaCapiEventLogDetail,
  MetaCapiEventLogDetailSchema,
  type MetaCapiEventLogListQuery,
  type MetaCapiEventLogListResponse,
  MetaCapiEventLogListResponseSchema,
  type SendCapiTestEventRequest,
  type SendCapiTestEventResponse,
  SendCapiTestEventResponseSchema,
} from '@utazzo/shared';

import { apiClient } from '@/lib/api-client';

/**
 * Meta CAPI admin API (ADR-0066). Ad-account credentials are managed in the
 * Secrets Manager, so this surface only reads config status, the
 * delivery log, and fires test events / retries. Every response is `.parse()`-d.
 */

export const getMetaCapiConfig = async (): Promise<MetaCapiConfigStatus> => {
  const { data } = await apiClient.get<unknown>('/meta-capi/config');
  return MetaCapiConfigStatusSchema.parse(data);
};

export const sendMetaCapiTestEvent = async (
  payload: SendCapiTestEventRequest,
): Promise<SendCapiTestEventResponse> => {
  const { data } = await apiClient.post<unknown>('/meta-capi/test-event', payload);
  return SendCapiTestEventResponseSchema.parse(data);
};

export const listMetaCapiEvents = async (
  query: MetaCapiEventLogListQuery,
): Promise<MetaCapiEventLogListResponse> => {
  const { data } = await apiClient.get<unknown>('/meta-capi/events', { params: query });
  return MetaCapiEventLogListResponseSchema.parse(data);
};

export const getMetaCapiCohortSummary = async (): Promise<MetaCapiCohortSummaryResponse> => {
  const { data } = await apiClient.get<unknown>('/meta-capi/events/summary');
  return MetaCapiCohortSummaryResponseSchema.parse(data);
};

export const getMetaCapiEvent = async (id: string): Promise<MetaCapiEventLogDetail> => {
  const { data } = await apiClient.get<unknown>(`/meta-capi/events/${id}`);
  return MetaCapiEventLogDetailSchema.parse(data);
};

export const retryMetaCapiEvent = async (id: string): Promise<void> => {
  await apiClient.post(`/meta-capi/events/${id}/retry`);
};
